import { Col, Form, InputNumber } from 'antd'
import React from 'react'

const PunchPressFields = ({ prefix }) => {
  return (
    <>
      <Col xs={24} md={6}>
        <Form.Item
          label="Part Weight"
          name={[prefix, "part_weight"]}
          rules={[
            {
              required: true,
              message: "Please input Part weight...!",
            },
          ]}
        >
          <InputNumber
            defaultValue={0}
            precision={2}
            addonAfter="gm"
            placeholder="Part Weight"
            style={{ width: "100%" }}
            size="small"
          />
        </Form.Item>
      </Col>
      <Col xs={24} md={6}>
        <Form.Item
          label="Press Cycle"
          name={[prefix, "press_cycle"]}
          rules={[
            {
              required: true,
              message: "Please input Press Cycle...!",
            },
            {
              type: "number",
              min: 1,
              message: "Press Cycle must be at least 1",
            },
          ]}
        >
          <InputNumber
            defaultValue={1}
            placeholder="press_cycle"
            style={{ width: "100%" }}
            size="small"
          />
        </Form.Item>
      </Col>
      <Col xs={24} md={6}>
        <Form.Item
          label="Units / box"
          name={[prefix, "units_per_box"]}
          rules={[
            {
              required: true,
              message: "Please Enter Units Per Box...!",
            },
              {
              type: "number",
              min: 1,
              message: "Units Per Box must be at least 1",
            },
          ]}
        >
          <InputNumber
            defaultValue={1}
            placeholder="Units Per Box"
            style={{ width: "100%" }}
            size="small"
          />
        </Form.Item>
      </Col>
    </>
  )
}

export default PunchPressFields